import React from "react";
import { Modal } from "sprint-common-web";

import { CompleteRejectedOrderForm } from "./CompleteRejectedOrderForm";

export interface CompleteRejectedOrderModalProps {
    orderId: string;
    isOpen: boolean;
    onCancel(): void;
    onSubmit(completionDetails?: string): void;
}

export const CompleteRejectedOrderModal: React.VFC<CompleteRejectedOrderModalProps> = ({
    orderId,
    onCancel,
    onSubmit,
    isOpen
}: CompleteRejectedOrderModalProps) => {
    return (
        <Modal headerText="Complete rejected order" onDismiss={onCancel} isBlocking={true} isOpen={isOpen}>
            <CompleteRejectedOrderForm orderId={orderId} onCancel={onCancel} onSubmit={onSubmit} />
        </Modal>
    );
};
